
{
  "fr": {
    "submit": "Personnaliser",
    "go": "GO"
  }
}
